<template>
    <div
        v-tinymce="options"
        :key="renderKey"
        @mce-change="(ekomi) => offerSectionSet({ ekomi: ekomi })"
        @mce-dirty="() => $emit('dirty')"
        v-bind:style="{ height: '100%' }"
    >
        <div class="card shadow-none ekomi d-flex justify-content-center">
            <div class="ekomi-wrapper">
                <a
                    data-gtm-ekomi=""
                    href="https://www.ekomi.de/bewertungen-gfunet.html"
                ><img src="https://www.gfu.net/images/ekomi-1.gif"></a>
            </div>
            <p>{{ $t('ekomi.description') }}</p>
            <p>{{ $t('ekomi.findUs') }}<br><a
                    data-gtm-ekomi=""
                    href="https://www.ekomi.de/bewertungen-gfunet.html"
                >www.ekomi.de/bewertungen-gfunet.html</a></p>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
export default {
    name: 'Ekomi',
    props: {
        options: Object
    },
    data() {
        return {
            renderKey: 0
        }
    },
    computed: {
        ...mapGetters(['offerSections'])
    },
    methods: {
        ...mapMutations([
            'offerSectionSet',
        ])
    },
    watch: {
        options: function () {
            this.renderKey++;
        }
    }
}
</script>

<style scoped></style>
